import { FormControl, FormLabel } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { Product } from 'BrokerTsLib/src/enums'
import { InputGroup } from '../../../components/InputGroup'
import { useNameof } from '../../../hooks/useNameof'
import { FormRow } from '../FormRow'
import { PhoneInputGroup } from './PhoneInputGroup'

const InsureeContact = ({ personPrefix, isDisabled = false, emailRequired = false, mobileRequired = false }:
{ personPrefix: string, isDisabled?: boolean, emailRequired?: boolean, mobileRequired?: boolean }) => {

  const { product, app } = useApp()
  const nameof = useNameof<PersonAdditionalData>(personPrefix)
  const { register, getFieldState } = useFormContext()

  const { error: errorMobilePhone } = getFieldState(nameof(x => x.mobilePhone))
  const { error: errorPhone } = getFieldState(nameof(x => x.phone))
  const { error: errorEmail } = getFieldState(nameof(x => x.email))

  return (
    <>
      {/* rozdělení do dvou řádek kvůli tomu, že políčko na email je příliš krátké */}
      <FormRow itemsCount={2}>
        <FormControl isInvalid={!!errorMobilePhone?.message} isRequired={mobileRequired}>
          <FormLabel>Mobilní telefon</FormLabel>

          <PhoneInputGroup
            select={{ ...register(nameof(x => x.mobilePhonePrefix)), isDisabled }}
            input={{ ...register(nameof(x => x.mobilePhone)), isDisabled }}
            errors={errorMobilePhone} />
        </FormControl>

        {product != Product.VehicleLeasingInsurance && app != Apps.publicPoleas &&
          <FormControl isInvalid={!!errorPhone?.message}>
            <FormLabel>Jiný telefon</FormLabel>

            <PhoneInputGroup input={{ ...register(nameof(x => x.phone)), isDisabled }} errors={errorPhone} />
          </FormControl>
        }

        <FormControl isInvalid={!!errorEmail?.message} isRequired={emailRequired}>
          <FormLabel>E-mail</FormLabel>

          <InputGroup type="email" {...register(nameof(x => x.email))} isDisabled={isDisabled} errors={errorEmail} />
        </FormControl>
      </FormRow>
    </>
  )
}

export default InsureeContact